
import UserService from './UserService';
import { store } from '../redux/store'; // Adjust path if needed
import { logoutUser } from '../redux/actions';
import { PERMISSIONS } from '../utils/constants';
import { setCatalogAuthorizationHeader } from '../utils/NewCatalogAPI';
import { setAuthorizationHeader } from '../utils/UserAPI';
import sierraPartsXRefService from './RedirectService';

let userInfo = null;
let hasCartAccess = false;
let hasUltraAccess = false;
let hasWarrantyAccess = false;
let loggedOut = false;
let tokenStatus = 0; //0: false, 1: verifying, 2: valid
let loginWallOn = (process.env.REACT_APP_LoginWallOn==='true');
let sierraPartsURL = process.env.REACT_APP_SIERRAPARTS;

const isUserLoggedIn = async(requestedPath) => {

  let userToken = store.getState().login.userToken;
  let userLoggedIn = store.getState().login.logged;
  console.log("userInfoService.isUserLoggedIn.loginState:", userLoggedIn);
  console.log("userInfoService.isUserLoggedIn.tokenStatus:", tokenStatus);

  if (userLoggedIn) {
  //if (userToken) {
    // I don't think its necessary to completely validate the 
    // token because subsequent steps will do that

    // if (tokenStatus==0){
    //   tokenStatus=1;
    //   await fetch(userToken);
    // }
    return true;
  }
  else {
    await redirectUser(requestedPath);
    return false;
  }
}

const redirectUser = async(requestedPath="") => {
  
    console.log("userInfoService.redirectUser.loggedOut, loginWallOn: ", loggedOut, loginWallOn);
    store.dispatch(logoutUser());

    if (!loggedOut && loginWallOn)
    {

      let id = 0;
      if (requestedPath.indexOf("product")>0)
        id = requestedPath.split('/').pop();

      console.log("userInfoService.redirectUser.requestPath: ", requestedPath, id);
      
      let _redirect = getRedirectRoute(requestedPath, id)
      console.log("userInfoService.redirectUser.redirectPath: ", _redirect);
      
      loggedOut = true;
      window.location.href = _redirect;
      return false;
    }
}

const getRedirectRoute = (path, id) =>{
  let redirectRoute = null;

  if (id>0)
  {
    const customerItem = sierraPartsXRefService.getCustomerItemById(id);
    if (customerItem)
      redirectRoute = sierraPartsURL + "/sku/" + customerItem;
  }

  if (!redirectRoute)
  {
    switch(path) {
      case "/":
        redirectRoute = "/en-us";
        break;
      case "/marine":
        redirectRoute = "/en-us/sierra"
        break;
      case "/marine/1":
        redirectRoute = "/en-us/sierra/engine-and-drive"
        break;
      case "/marine/2":
        redirectRoute = "/en-us/sierra/accessories"
        break;
      case "/marine/4":
        redirectRoute = "/en-us/sierra/hose"
        break;
      case "/marine/5":
        redirectRoute = "/en-us/sierra/instrumentation"
        break;
      case "/marine/6":
      case "/marine/9":
        redirectRoute = "/en-us/dometic/food-and-beverage"
        break;
      case "/marine/7":
        redirectRoute = "/en-us/sierra/oils-and-lubes"
        break;
      case "/marine/10":
        redirectRoute = "/en-us/dometic/hygiene-and-sanitation"
        break;
      case "/marine/11":
        redirectRoute = "/en-us/dometic/power-and-control"
        break;
      case "/marine/12":
        redirectRoute = "/en-us/sierra/tanks"
        break;
      case "/marine/13":
        redirectRoute = "/en-us/sierra/tools-and-shop-supplies"
        break;
      case "/marine/18":
        redirectRoute = "/en-us/sierra/power-systems"
        break;
      default:
        redirectRoute = "/en-us/parts-finder"; //root
    }

    redirectRoute = sierraPartsURL + redirectRoute;
  }

  return redirectRoute;
}

const fetch = async (userToken) => {
    console.log("userInfoService.fetch.userInfoExists: ", (userInfo!=null));
    //console.log("userInfoService.fetch.userToken: ", userToken);

    //if (!userToken)
    //  return isUserLoggedIn("");

    setCatalogAuthorizationHeader(userToken);
    setAuthorizationHeader(userToken);

    if (!userInfo) {
      try {
        const user = await UserService.getUserInfo();
        console.log("userInfoService.fetch.response: ", user.data);
  
        if (user.status === 200) {
          const msg = user.data.results?.Message?.toLowerCase() || '';
          if (msg.includes("not authorized")) {
            console.log("userInfoService.fetch.NotAuthorized ");
            tokenStatus=0;
            redirectUser();
            return false;
          }

          tokenStatus=2; //valid
  
          userInfo = user.data.data;
  
          hasCartAccess = userInfo?.Permissions?.some(
            p => p.PermissionGroupsId === PERMISSIONS.ShoppingCartAccess
          ) || false;
  
          hasUltraAccess = userInfo?.Permissions?.some(
            p => p.PermissionGroupsId === PERMISSIONS.HasUltraAccess
          ) || false;

          hasWarrantyAccess = userInfo?.Permissions?.some(
            p => p.PermissionGroupsId === PERMISSIONS.WarrantyFullAccess
          ) || false;

          return true;
        }
      } catch (err) {
        console.error("Error fetching user info:", err);
        redirectUser();
        return false;
      }
    }
  
    return true;
  };
  

export const UserInfoService = {
  fetch,
  redirectUser,
  isUserLoggedIn,

  get userInfo() {
    return userInfo;
  },
  get hasCartAccess() {
    return hasCartAccess;
  },
  get hasUltraAccess() {
    return hasUltraAccess;
  },
  get hasWarrantyAccess() {
    return hasWarrantyAccess;
  },

//   get checkShippingFlag() {
//     return checkShippingFlag;
//   },
//   setCheckShippingFlag(val) {
//     checkShippingFlag = val;
//   }
};
